import { render, staticRenderFns } from "./EnablePaymentSettings.vue?vue&type=template&id=604e88c4&"
import script from "./EnablePaymentSettings.vue?vue&type=script&lang=js&"
export * from "./EnablePaymentSettings.vue?vue&type=script&lang=js&"
import style0 from "./EnablePaymentSettings.vue?vue&type=style&index=0&id=604e88c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports